export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const INVESTOR = 'INVESTOR';
export const BANKER = 'BANKER';
export const VISITOR = 'VISITOR';
export const SUPER = 'SUPER';

export function canUpgradeToInvestor(roles = {}) {
  return !!roles[USER] && !roles[INVESTOR] && !roles[BANKER];
}

export function canUpgradeToBanker(roles = {}) {
  return !!roles[INVESTOR] && !roles[BANKER];
}
